<ul class="nav nav-tabs cv-nav-tabs" role="tablist" #myDivv>
	<ng-container *ngFor="let tab of tabs; let i = index">
		<li *ngIf="tabsData[i].visible && tabsData[i].tabSectionMode === tabSectionMode.TAB"
			class="nav-item cv-nav-tabs_tab"
			role="presentation"
			data-tabs>
			<a data-toggle="tab" class="nav-link"
				[ngClass]="{
					active: selectedItem === i
				}"
				[href]="'#' + tabsData[i].id"
				(click)="select(i, $event)">
				{{tab.title}} ({{tabsData[i].data.photos.length}})
			</a>
		</li>
		<li class="tab-section-mode-button" *ngIf="tabsData[i].visible && tabsData[i].tabSectionMode === tabSectionMode.DROPDOWN">
			<cv-schema-render-component [layoutNode]="tab" [data]="tabsData[i].data"></cv-schema-render-component>
		</li>
	</ng-container>
</ul>

<div class="tab-content">
	<ng-container *ngIf="!tabsInitialized">
		<div class="cv-tab-pane-placeholder d-flex justify-content-center align-items-center">
			<h1 class="ml-1">
				<i class="fas fa-spinner fa-spin"></i>
			</h1>
		</div>
	</ng-container>
	<ng-container *ngFor="let tab of tabs; let i = index">
		<div *ngIf="tabsData[i].visible"
			class="tab-pane cv-tab-pane"
			role="tabpanel"
			[id]="tabsData[i].id"
			[ngClass]="{
				'active': selectedItem === i
			}">

			<ng-container *ngIf="selectedItem === i && tabsData[i].tabSectionMode === tabSectionMode.TAB">
				<cv-schema-render-component [layoutNode]="tab" [data]="tabsData[i].data"></cv-schema-render-component>
			</ng-container>
		</div>
	</ng-container>
</div>
